// extracted by mini-css-extract-plugin
export default {"classic":"styles_classic__iq8rb","float":"styles_float__cT74I","icon":"styles_icon__qiOrA"};